export default __webpack_public_path__ + "static/media/051-angle.f0e82ead.svg";